import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

type DraftRow = Record<string, unknown>;

export type ImportReviewDraftEntry = {
  uploadedFilePath: string;
  rows: DraftRow[];
  updatedAt: number;
};

type ImportReviewDraftState = {
  drafts: Record<string, ImportReviewDraftEntry>;
};

const INITIAL_STATE: ImportReviewDraftState = {
  drafts: {},
};

const importReviewDraftSlice = createSlice({
  name: 'importReviewDraft',
  initialState: INITIAL_STATE,
  reducers: {
    upsertImportReviewDraft(
      state,
      action: PayloadAction<{
        key: string;
        uploadedFilePath: string;
        rows: DraftRow[];
      }>
    ) {
      const { key, uploadedFilePath, rows } = action.payload;
      if (!key || !uploadedFilePath) return;
      state.drafts[key] = {
        uploadedFilePath,
        rows,
        updatedAt: Date.now(),
      };
    },
    clearImportReviewDraft(state, action: PayloadAction<{ key: string }>) {
      const { key } = action.payload;
      if (!key) return;
      delete state.drafts[key];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { upsertImportReviewDraft, clearImportReviewDraft } =
  importReviewDraftSlice.actions;

export default importReviewDraftSlice.reducer;

